module.exports = {
    "add.topic": "发布帖子",
    "topic.title": "标题",
    "topic.tag": "标签, 按回车键分隔",
    "tip.input.title": "标题不能为空",
    "my.topic": "发布的帖子",
    "reply.topic": "评论的帖子",
    "new.topic": "我要发帖",
    "search.placeholder": "搜索问题...",
    "content.length": "你输入的内容过短",
    "content.length.max": "你输入的内容过多",
    "tags.length": "标签内容不能超过{{max}}个字符",
    "tags.count": "标签个数不能超过{{max}}个",
    "all": "全部",
    "essence.title": "精华"
}


// WEBPACK FOOTER //
// ./src/pages/home/i18n/locale.zh-cn.js